import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as s, createElementVNode as o } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconGreenhouse",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(r).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(a, t, i, _, f, e) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: s([e.iconSizeClass, "d-icon d-icon--greenhouse"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Greenhouse",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    o("path", {
      d: "M14.767 8.821c0 .784-.331 1.477-.874 2.02-.603.603-1.477.754-1.477 1.266 0 .693 1.115.482 2.185 1.552.709.709 1.146 1.643 1.146 2.728 0 2.14-1.718 3.844-3.874 3.844C9.718 20.23 8 18.529 8 16.389c0-1.085.437-2.02 1.145-2.728 1.07-1.07 2.186-.86 2.186-1.553 0-.512-.874-.663-1.477-1.266-.543-.542-.874-1.235-.874-2.05a2.843 2.843 0 0 1 2.848-2.833c.302 0 .573.046.799.046.407 0 .618-.181.618-.468 0-.165-.075-.376-.075-.603 0-.512.437-.934.964-.934.528 0 .95.437.95.965 0 .557-.437.813-.769.934-.271.09-.482.211-.482.482 0 .511.934 1.009.934 2.44Zm-.301 7.568c0-1.492-1.1-2.698-2.593-2.698-1.492 0-2.592 1.206-2.592 2.698 0 1.477 1.1 2.698 2.592 2.698 1.493 0 2.593-1.223 2.593-2.698Zm-.89-7.598c0-.95-.768-1.733-1.703-1.733-.934 0-1.703.784-1.703 1.733 0 .95.769 1.733 1.703 1.733.935 0 1.704-.783 1.704-1.733Z",
      fill: "#23A47F"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ l(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=greenhouse.js.map
